import { createContext } from 'react';

export interface ITableContext {
    zoomCanvas: number;
    onZoomChange?: React.Dispatch<React.SetStateAction<number>>;
}

export const TablePlanContext = createContext<ITableContext>({ zoomCanvas: 1 });
